import type { AxiosResponse, Method } from 'axios';

export interface TRequestInstance<Data> {
	url: string;
	method: Method;
	data?: Data;
	params?: object;
	signal?: AbortSignal;
	token?: string;
	headers?: object;
	timeout?: number;
}
export const requestInstanceV2 = async <Data, Response = void>({
	url,
	method,
	data,
	params,
	signal,
	token,
	headers,
	timeout,
}: TRequestInstance<Data>): Promise<AxiosResponse<Response>> => {
	const axios = (await import('axios')).default;
	const axiosData = {
		method,
		url,
		data,
		params,
		signal,
		headers,
		...(timeout !== undefined && { timeout }),
	};

	if (token?.length) {
		axiosData.headers = {
			...axiosData.headers,
			Authorization: `Bearer ${token}`,
		};
	}

	return await axios({
		...axiosData,
	});
};
